
export default {
  methods: {
    closeModal(){
      this.$emit('closeModal')
    }
  }
}
